import React from 'react';
import { BaseMenuItem, BaseMenuItemProps } from './BaseMenuItem';

export type MenuActionProps = Omit<
  BaseMenuItemProps,
  'closeOnClick' | 'highlighted' | 'selected'
>;

export const MenuAction: React.FC<MenuActionProps> = (props) => (
  <BaseMenuItem {...props} closeOnClick={false} />
);

MenuAction.displayName = 'MenuAction';
